// import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import "../Components/Assets/CSS/Contact.css";
import contactUs from "../Components/Assets/Images/contactUs1.jpg";
import { motion } from "framer-motion";
import PageCover from "../Components/Shared/PageCover";
import { Box, Typography, TextField, Button } from "@mui/material";
import { Row, Col, Image, Form } from "react-bootstrap";
import contactCover from "../Components/Assets/Images/contactCover.jpg";
import { mapLink } from ".././Components/Shared/OurTeamData";

const Contact = () => {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   email: "",
  //   subject: "",
  //   message: "",
  // });

  // const [snackbarOpen, setSnackbarOpen] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [error, setError] = useState(false);

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const res = await fetch("http://localhost:5000/api/auth/contact", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(formData),
  //     });

  //     const data = await res.json();
  //     setSnackbarMessage(data.message);
  //     setSnackbarOpen(true);
  //     setError(!res.ok);

  //     if (res.ok) {
  //       setFormData({ name: "", email: "", subject: "", message: "" });
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     setSnackbarMessage("Network error. Try again later.");
  //     setSnackbarOpen(true);
  //     setError(true);
  //   }
  // };

  return (
    <>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
        viewport={{ once: false, amount: 0.5 }}
      >
        <PageCover
          image={contactUs}
          title="Contact Us"
          subtitle="Welcome to Our World, Where Innovation Meets Purpose, and Possibilities Unfold"
        />
      </motion.div>
      <Box as="section" className="contactMap">
        {/* <Container> */}
        <Row>
          <Col lg={6} md={12} sm={12}>
            <iframe
              src={mapLink}
              title="Office location map"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              className="contactMap"
            ></iframe>
          </Col>
          <Col lg={6} md={12} sm={12} style={{ padding: "50px 40px 0 40px" }}>
            <Row>
              <Col lg={12}>
                <Typography variant="h2">
                  Feel free to get in touch with <br /> Shankh air
                </Typography>
                <Typography variant="body2" style={{}}>
                  We’re here to assist you with your travel needs, queries, and
                  feedback. Whether you're looking for support, information, or
                  guidance — we’re just a message away.
                </Typography>
              </Col>
              <Col lg={8} sm={12}>
                <Box
                  component="a"
                  target="_blank"
                  href="https://wa.me/9935152025"
                  sx={{ textDecoration: "none", color: "inherit" }}
                  className="contactCard"
                >
                  <Box className="icon">
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </Box>
                  <Box className="contactInfo">
                    <Box className="testimonial mb-0">
                      <Typography
                        sx={{
                          color: "#fff",
                          zIndex: "9",
                          position: "relative",
                          lineHeight: "30px",
                          fontWeight: "600",
                        }}
                        component="span"
                      >
                        Connect us
                      </Typography>
                    </Box>
                    <Typography variant="body1">+91 9935152025</Typography>
                  </Box>
                </Box>
              </Col>
              <Col lg={8} sm={12}>
                <Box
                  className="contactCard"
                  component="a"
                  href="mailto:contactus@shankhair.com"
                  sx={{ textDecoration: "none", color: "inherit" }}
                >
                  <Box className="icon">
                    <FontAwesomeIcon icon={faEnvelopeOpen} />
                  </Box>
                  <Box className="contactInfo">
                    <Box className="testimonial mb-0">
                      <Typography
                        sx={{
                          color: "#fff",
                          zIndex: "9",
                          position: "relative",
                          lineHeight: "30px",
                          fontWeight: "600",
                        }}
                        component="span"
                      >
                        write us
                      </Typography>
                    </Box>
                    <Typography variant="body1">
                      contactus@shankhair.com
                    </Typography>
                  </Box>
                </Box>
              </Col>
              <Col lg={8} sm={12}>
                <Box className="contactCard">
                  <Box className="icon">
                    <FontAwesomeIcon icon={faLocationDot} />
                  </Box>
                  <Box className="contactInfo">
                    <Box className="testimonial mb-0">
                      <Typography
                        sx={{
                          color: "#fff",
                          zIndex: "9",
                          position: "relative",
                          lineHeight: "30px",
                          fontWeight: "600",
                        }}
                        component="span"
                      >
                        Locate us
                      </Typography>
                    </Box>
                    <Typography variant="body1">
                      Gomti Nagar Extension, Lucknow, Uttar Pradesh (India)
                    </Typography>
                  </Box>
                </Box>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* </Container> */}
      </Box>
      <Box
        as="section"
        className="contactformBox"
        style={{ padding: "60px 0 0" }}
      >
        <Row>
          <Col lg={6} className="p-0 contactFormImg relative">
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 100, opacity: 0 }}
              transition={{ duration: 1.3, ease: "easeInOut" }}
              viewport={{ once: false, amount: 0.5 }}
            >
              <Image
                src={contactCover}
                className="img-fluid contactformImage"
              ></Image>
              <Box className="contactformImageText">
                <Typography variant="h2">
                  Any Question?
                  <br /> Fell Free to Contact
                </Typography>
                <Typography variant="body2">
                  Have any query? Feel free to contact us! We are here to help
                  you with all your needs. Reach out today, and let us assist
                  you in finding the perfect solution.
                </Typography>
              </Box>
            </motion.div>
          </Col>
          <Col lg={6} className="p-0">
            <Box
              className="contactForm bookTextfield p-5"
              style={{ background: "#ecf5fd" }}
            >
              <Form>
                <Row>
                  <Col lg={12} className="mb-4">
                    <Typography variant="h2">Get in touch with us.</Typography>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <TextField
                      id="outlined-basic"
                      className="bg-white"
                      label="Name"
                      variant="outlined"
                      fullWidth
                    />
                  </Col>
                  <Col lg={6} className="mb-4">
                    <TextField
                      id="outlined-basic"
                      label="Email"
                      className="bg-white"
                      variant="outlined"
                      fullWidth
                    />
                  </Col>
                  <Col lg={6} className="mb-4">
                    <TextField
                      id="outlined-basic"
                      label="Phone"
                      className="bg-white"
                      variant="outlined"
                      fullWidth
                    />
                  </Col>
                  <Col lg={6} className="mb-4">
                    <TextField
                      id="outlined-basic"
                      label="Subject"
                      className="bg-white"
                      variant="outlined"
                      fullWidth
                    />
                  </Col>
                  <Col lg={12} className="mb-4">
                    <TextField
                      label="Your Message"
                      multiline
                      rows={4}
                      variant="outlined"
                      fullWidth
                      className="bg-white"
                    />
                  </Col>
                  <Col lg={12} className="mb-3 btnWrapper text-end">
                    <Button
                      type="submit"
                      className="coverBtn bg-orange btnIcon btn btn-link"
                    >
                      <Typography
                        component={"span"}
                        style={{ fontSize: "16px", fontWeight: "600" }}
                      >
                        Send Message <FontAwesomeIcon icon={faPaperPlane} />
                      </Typography>
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Box>
          </Col>
        </Row>
      </Box>
    </>
  );
};

export default Contact;
